module.exports = __webpack_public_path__ + "img/illustration-01.fbfaf137.png";